export interface AnswerReqInterface {
  /**
   * 分配学案id
   */
  handoutId: number
  /**
   * 分配学案的目录id
   */
  outlineId: number
  /**
   * 题目id
   */
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否已发布
   */
  isPublished?: boolean
}

export class AnswerReq implements AnswerReqInterface {
  /**
   * 分配学案id
   */
  handoutId: number
  /**
   * 分配学案的目录id
   */
  outlineId: number
  /**
   * 题目id
   */
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否已发布
   */
  isPublished?: boolean

  constructor(props: AnswerReqInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      handoutId: _handoutId,
      outlineId: _outlineId,
      questionId: _questionId,
      value: _value,
      isPublished: _isPublished,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.handoutId = _handoutId
    this.outlineId = _outlineId
    this.questionId = _questionId
    this.value = _value
    this.isPublished = _isPublished
  }
}
